export const APP_HEADER_ELEMENTS = ['Calendar', 'Calculator', 'Universal Affinities', 'Villager Directory', 'Random Events', 'Common Benchmarks']